module.exports = __webpack_public_path__ + "assets/img/newimgdj.43f8e1f5.png";